module.exports = __webpack_public_path__ + "static/AvenirNextLTPro-HeavyCnIt-5cbfc7aa555df235b8e6a9a5a7d6c596.woff2";